import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import NoIndex from "../NoIndex";
import { Modal, Button, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import eye from "../../images/EYE.png";
import Edit from "../../images/message-edit.png";
import { useNavigate } from "react-router-dom";
import { Form, FormControl } from "react-bootstrap";
import Pagination from "./Pagination";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import pause from "../../images/Pause.png";
import Play from "../../images/Play.png";
import { CheckCircle, XCircle, PauseCircle, Clock, PlayCircle, AlertCircle, Calendar, XOctagon } from "lucide-react";
import Swal from "sweetalert2";
import MyContext from "../../MyContext";
import refreshicon from "../../images/refresh-2.svg"
import Placeholder from "../../images/Place Holder 3 1.webp"
import Placeholder1 from "../../images/Place Holder.webp"
import Placeholder2 from "../../images/Place Holder_1.webp"
import excel from "../../images/excel (2).svg"

import loader from "../../images/Sendbulkmessage.svg"



const Campaign = ({ userID }) => {

  const { baseUrl, config } = useContext(MyContext);
  const [Campaign, setCampaign] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [animate, setAnimate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Show 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteState, setdeleteState] = useState("");
  const [ExcuteDelete, setExcuteDelete] = useState("");
  const [ModalData, setModalData] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [ErrorDelete, setErrorDelete] = useState();
  const [variables, setVariables] = useState([]);
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const handleClick = (type) => {
    if (type === "prev") {
      setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
    } else if (type === "next") {
      setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
    }
  };
  const handlePageClick = (pageNumber) => {
    if (
      pageNumber !== currentPage &&
      pageNumber >= 1 &&
      pageNumber <= totalPages
    ) {
      setCurrentPage(pageNumber);
      // Perform any action here, like fetching data for the new page
    }
  };
  const navigate = useNavigate();
  const handleEditClick = (
    campaignId,
    campaignName,
    startDate,
    endDate,
    interval,
    template,
    channel,
    status,
    members
  ) => {
    navigate(
      `/CampaignDetails?campaignId=${campaignId}&interval=${interval}&campaignName=${campaignName}&startDate=${startDate}&endDate=${endDate}&template=${template}&channel=${channel}&status=${status}&members=${members}`
    );
  };

  const handleViewClick = (campaignId, campaignName) => {
    navigate(
      `/WhatsApp/Manage/CampaignView?campaignId=${campaignId}&campaignName=${campaignName}`
    );
  };
  useEffect(() => {
    setAnimate(false);
    setTimeout(() => setAnimate(true), 10);
  }, [templates]);

  const replaceVariablesBody = (text) => {
    const replacements = ["John Doe", "Messaging"]; // Replace with dynamic values
    return text.replace(/{{(\d+)}}/g, (_, index) => replacements[index - 1] || "");
  };
  // fetching the campaigns using the Anlook api.
  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
  const getCampaign = async (e) => {
    try {
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify({
        userid: userID,
        campaignName: "string",
        phoneNumberId: SingleWhatsApp
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Campaign/v1.0/getCampaigns`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setCampaign(data?.data);
      } else {
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };
  useEffect(() => {
    getCampaign();
    getTemplates();
  }, [SingleWhatsApp]);

  // Handle preview button click
  const handlePreview = (templateId) => {
    setIsLoading(true);
    setShowModal(true);

    // Simulating API call delay
    setTimeout(() => {
      const template = templates.find((temp) => temp.name === templateId);
      setSelectedTemplate(template);
      setIsLoading(false);
    }, 0);
  };


  function handleModal(item) {
    setModalData(item);
  }
  function handleDelete(item) {
    setdeleteState(item);
    SetExecute();
  }
  function SetExecute() {
    setExcuteDelete("delete");
  }
  const DeleteCampaign = async (e) => {
    try {
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);

      var raw = JSON.stringify({
        userid: userID,
        secret: "string",
        campaignId: deleteState,
        status: "string",
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Campaign/deleteCampaign`,
        requestOptions
      );




      const data = await res.json();
      if (deleteState !== "") {
        toast.success(data.responseMessage);
        setErrorDelete(data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };

  const onoffapi = async (id, status) => {
    try {
      const myHeaders = {
        "Content-Type": "application/json",
        Authorization: `Basic ${BASIC_AUTH}`,
      };

      const requestBody = {
        userid: userID,
        secret: "string",
        campaignId: id,
        status: status === "Y" ? "N" : "Y", // Toggle status
      };

      const response = await axios.post(
        `${baseUrl}/api/Campaign/changeCampaignStatus`,
        requestBody,
        { headers: myHeaders }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        getCampaign();
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error toggling campaign status:", error);
    }
  };

  useEffect(() => {
    DeleteCampaign();
  }, [ExcuteDelete]);



  // Pagination values defined here
  const sortedData = Campaign.sort(
    (a, b) => new Date(b.campaign_start) - new Date(a.campaign_start)
  );

  // pagination values defined here
  const data = sortedData.filter(
    (item) =>
      item.campaign_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.campaign_start?.includes(searchTerm) ||
      item.campaign_end?.includes(searchTerm) ||
      item.campaign_interval?.includes(searchTerm) ||
      item.channel?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const endIndex =
    currentPage === totalPages ? Campaign?.length : startIndex + itemsPerPage;
  const currentItems = data?.slice(startIndex, endIndex);

  // Edit campaign states loading
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // Initialize tooltips when component mounts
    const tooltips = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltips?.map((tooltip) => new window.bootstrap.Tooltip(tooltip));

    // Clean up tooltips when component unmounts
    return () => {
      tooltips?.map((tooltip) => tooltip?.dispose());
    };
  }, []);
  const handleStatusChange = (id, status) => {
    Swal.fire({
      title: `Are you sure you want to ${status === "Y" ? "Stop" : "Start"
        } this campaign?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        onoffapi(id, status);
      }
    });
  };
  function refresh() {
    getCampaign();
  }
  //geting Whatsapp number register
  const getWhatsappNumber = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`,
        requestOptions,
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setWhatsappNumbers(data?.response);
      } else {
      }
    } catch (error) { }
  };
  useEffect(() => {
    getWhatsappNumber();
  }, []);
  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.map((Num, i) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.map((Num, i) => i === 0 ? setSingleWhatsApp(Num.phone_no_id) : "");
    }
  }, [WhatsappNumbers]);
  const getTemplates = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify({
        userid: userID,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/getTemplates`,
        requestOptions,
      );

      const data = await res.json();

      if (data?.responseCode === "00") {
        setTemplates(data?.response?.data);
      } else {
        console.error("Failed to fetch templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  const formatWhatsAppText = (text) => {
    if (!text) return "";

    return text
      .replace(/_\*(.*?)\*_/g, "<b><i>$1</i></b>") // Bold + Italic
      .replace(/\*(?!_)(.*?)\*(?!_)/g, "<b>$1</b>") // Bold (avoiding _*...*_ conflicts)
      .replace(/_(?!\*)(.*?)_(?!\*)/g, "<i>$1</i>"); // Italic (avoiding _*...*_ conflicts)
  };

  const replaceVariables = (body) => {
    if (!body) return "";

    let replacedText = body.replace(/\{\{(\d+)\}\}/g, (match, number) => {
      const variableIndex = parseInt(number) - 1;
      const variable = variables[variableIndex];
      return variable ? variable.value : "";
    });

    return formatWhatsAppText(replacedText); // Apply formatting
  };

  const thStyle = {
    backgroundColor: "#007bff",
    color: "white",
    padding: "8px",
    border: "1px solid #ddd",
  };

  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "center",
  };


  const StatusBadge = ({ status }) => {
    const statusMap = {
      running: { text: "Running", color: "#ffc107", icon: <PlayCircle size={16} /> },
      completed: { text: "Completed", color: "#28a745", icon: <CheckCircle size={16} /> },
      stopped: { text: "Stopped", color: "#dc3545", icon: <XCircle size={16} /> },
      failed: { text: "Failed", color: "#dc3545", icon: <XOctagon size={16} /> }, // Changed icon
      paused: { text: "Paused", color: "#17a2b8", icon: <PauseCircle size={16} /> },
      pending: { text: "Pending", color: "#6c757d", icon: <Clock size={16} /> },
      in_progress: { text: "In Progress", color: "#007bff", icon: <PlayCircle size={16} /> },
      scheduled: { text: "Scheduled", color: "#6610f2", icon: <Calendar size={16} /> },
      started: { text: "Started", color: "#007bff", icon: <PlayCircle size={16} /> }, // New status
    };
    const normalizedStatus = status.replace(/\s+/g, "_").toLowerCase();
    const { text, color, icon } = statusMap[normalizedStatus] || { text: status, color: "#6c757d", icon: null };
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          padding: "5px 12px",
          borderRadius: "20px",
          fontSize: "14px",
          fontWeight: "bold",
          textTransform: "capitalize",
          backgroundColor: color,
          color: "#fff",
        }}
      >
        {icon} {text}
      </span>
    );
  };

  return (
    <>
      <NoIndex />
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div>
        {/* Modal for template preview */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Message Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" />
                <p>Generating preview...</p>
              </div>
            ) : selectedTemplate ? (
              <div>
                <div className=" p-5 ">
                  <div className={`message-bubble border bg-light ${animate ? "message-bubble-animate " : ""}`}>
                    {/* HEADER */}
                    <div className="d-flex justify-content-center">{selectedTemplate.components?.find(c => c.format === "IMAGE") ? <img src={Placeholder} alt="" style={{ width: "14rem" }} /> : ""}
                      {selectedTemplate.components?.find(c => c.format === "VIDEO") ? <img src={Placeholder1} alt="" style={{ width: "14rem" }} /> : ""}
                      {selectedTemplate.components?.find(c => c.format === "DOCUMENT") ? <img src={Placeholder2} alt="" style={{ width: "14rem" }} /> : ""}</div>
                    <div className="header-text">
                      {selectedTemplate.components?.find(c => c.type === "HEADER")?.text || ""}
                    </div>
                    {/* BODY */}
                    <div className="body-text py-1">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            replaceVariables(selectedTemplate.components.body).length > 605
                              ? replaceVariables(selectedTemplate.components.body).slice(0, 605) + "..."
                              : replaceVariables(selectedTemplate.components?.find(c => c.type === "BODY")?.text || ""),
                        }}
                      />
                    </div>
                    <>{console.log(selectedTemplate)}</>
                    {/* FOOTER */}
                    <div className="footer-text">
                      {selectedTemplate.components?.find(c => c.type === "FOOTER")?.text || ""}
                    </div>
                    <div className="footer-text text-end">05:27 PM</div>
                  </div>
                  {/* BUTTONS */}
                  {selectedTemplate.components
                    ?.find(c => c.type === "BUTTONS")?.buttons?.map((button, index) => (
                      <div key={index} className={`button-bubble ${animate ? "button-bubble-animate border mt-2" : ""}`}>
                        <div className="button-text text-success text-center mb-1">
                          {button.text}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <p>No template found.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div
          className="p-4 bg-white "
          style={{
            height: "100vh",
            fontFamily: "Nunito,sans-serif",
          }}
        >
          <div className=" px-4  justify-content-center ">
            <div className="Sendbulkmsg-campaign-container mb-4 bg-light">
              {/* Header Section */}
              <div className="Sendbulkmsg-header d-flex justify-content-between">
                <h2 className="CreateCampaign"> Manage Campaign</h2>
                <div className="d-flex">

                  {/* Action Buttons */}
                  <div className="Sendbulkmsg-actions">
                    <button className="Sendbulkmsg-create-btn" onClick={() => navigate("/WhatsApp/Campaign")}>
                      + Create New Campaign
                    </button>
                    <button className="Sendbulkmsg-refresh-btn text-success" onClick={() => refresh()}>
                      <img src={refreshicon} alt="Refresh" />
                    </button>
                  </div>
                </div>
              </div>

              <hr />

              {/* Top Controls - Search & WhatsApp Number */}
              <div className="Sendbulkmsg-controls d-flex justify-content-start">
                <div className="Sendbulkmsg-whatsapp ">
                  <label className="Sendbulkmsg-whatsapp-label single-line-css" > WhatsApp Number</label>
                  <select
                    className="Sendbulkmsg-whatsapp-dropdown"
                    value={SingleWhatsApp}
                    onChange={(e) => setSingleWhatsApp(e.target.value)}
                    disabled={!MultiplePhoneNumber}
                  >
                    <option value="">Select Number</option>
                    {WhatsappNumbers.map((num, index) => (
                      <option key={index} value={num.phone_no_id}>
                        {num.phone_no_id} - ({num.phone_no})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="Sendbulkmsg-whatsapp ">
                  <label className="Sendbulkmsg-whatsapp-label single-line-css" > Search campaigns</label>
                  <Form>
                    <FormControl
                      type="text"
                      placeholder=" Search campaigns..."
                      value={searchTerm}
                      className="Sendbulkmsg-search-input"
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Form>
                </div>


              </div>


            </div>
            {loading ? (
              <div className=" m-5 p-5 d-flex justify-content-center">
                <div className=" d-flex flex-column align-items-center justify-content-center ">
                  <div className="p-3">
                    <div className="loader"> </div>
                  </div>
                  <div className="p-3">
                    <img src={loader} alt="" height={40} />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <React.Fragment
                  className=""
                  style={{
                    border: "1px solid #dddddd",
                    borderRadius: "10px",
                  }}
                >

                  <div className="scrollable-table border-radius-10-left">
                    <table className="table table-bordered table-hover "  >
                      <thead style={{ borderRadius: "10px" }}>
                        <tr className="text-center   py-4">
                          <th className="pb-3 th-style ">S.No.</th>
                          <th
                            className="pb-3 th-style"

                          >
                            Campaign Name
                          </th>
                          <th
                            className="pb-3 th-style"

                          >
                            Campaign Type
                          </th>
                             <th
                            className="pb-3 th-style"

                          >
                            {" "}
                            Scheduled Time
                          </th>
                          <th
                            className="pb-3 th-style"

                          >
                            {" "}
                            Start Time
                          </th>
                          <th
                            className="pb-3 th-style"

                          >
                            End Time
                          </th>
                          <th
                            className="pb-3 th-style"

                          >
                            Status
                          </th>
                          <th
                            className="pb-3 th-style"
                          >
                            Audience
                          </th>
                          <th
                            className="pb-3 th-style"

                          >
                            Preview
                          </th>
                          <th
                            className="pb-3 th-style"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems?.map((item, index) => (
                          <tr
                            key={index}
                            style={
                              {
                                // borderBottom: "1px solid #DDD",
                                // padding: "5px 0px",
                              }
                            }
                          >
                            <td className="pt-4 text-center">
                              {index + startIndex + 1}
                            </td>
                            <td className="pt-4 text-center">{item.campaign_name}</td>
                              <td className="pt-4 text-center">{item.campaignType}</td>
                                <td className="pt-4 text-center">
                              {item.scheduledDateTime}
                            </td>
                            <td className="pt-4 text-center">
                              {item.campaign_start}
                            </td>
                            <td className="pt-4 text-center">{item.campaign_end}</td>
                            {/* <td className="pt-4 text-center">{"₹ "}{item.estimatedCost}</td> */}
                            <td className="pt-4 text-center">
                              <StatusBadge status={item.status} />
                            </td>
                            <td className="pt-4 text-center">
                              <a href={item.excel_url} download target="_blank" rel="noopener noreferrer" className="cursur-pointer ">
                                <img src={excel} alt="" height={30} />
                              </a>
                            </td>
                            <td className="pt-4 text-center">
                              <button onClick={() => { handlePreview(item.template_id) }} className="btn text-success bg-light">Preview</button>
                            </td>
                            <td className=" pt-4 text-center">
                              <span
                                className="cursor-pointer"
                                data-bs-placement="bottom"
                                title="View"
                                onClick={() => {
                                  handleViewClick(item.id, SingleWhatsApp);
                                }}
                              >
                                <img src={eye} alt="Logo" />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
                <>
                  <div
                    class="modal fade"
                    id="exampleModal1"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h1
                            class="modal-title fs-5 text-success"
                            id="exampleModalLabel"
                          >
                            {ModalData}
                          </h1>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>


                        <div class="modal-body">
                          Are you sure you want to delete this item? This action
                          cannot be undone.
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            id="liveAlertBtn"
                            type="button"
                            class="btn btn-danger"
                            // data-bs-toggle="modal"
                            // data-bs-target="#exampleModal2"
                            data-bs-dismiss="modal"
                            onClick={() => handleDelete(ModalData)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* //////////// */}


                  <div className="py-3">
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onNextPage={() => handleClick("next")}
                      onPrevPage={() => handleClick("prev")}
                      onPageClick={(e) => handlePageClick(e)}
                    />
                  </div>


                </>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Campaign;